import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { useState } from 'react';

export default function Layanan() {
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'Semua Layanan' },
    { id: 'kiloan', name: 'Kiloan' },
    { id: 'satuan', name: 'Satuan' },
    { id: 'cuci-setrika', name: 'Cuci + Setrika' },
    { id: 'setrika', name: 'Setrika' },
    { id: 'express', name: 'Express' }
  ];

  const services = [
    {
      id: 1,
      category: 'kiloan',
      icon: 'ri-scales-3-line',
      title: 'Laundry Kiloan',
      description: 'Cuci bersih pakaian per kilogram dengan proses pencucian profesional menggunakan deterjen berkualitas tinggi',
      basePrice: 'Rp 7.000',
      priceUnit: '/kg',
      estimatedTime: '2-3 hari',
      features: [
        'Cuci + kering',
        'Deterjen premium',
        'Pewangi pakaian',
        'Penanganan profesional',
        'Gratis antar jemput (min. 5kg)'
      ],
      pricing: [
        { weight: '3-5 kg', price: 'Rp 7.000/kg' },
        { weight: '6-10 kg', price: 'Rp 6.500/kg' },
        { weight: '> 10 kg', price: 'Rp 6.000/kg' }
      ],
      duration: '2-3 hari',
      image: 'https://public.readdy.ai/ai/img_res/73579c25cceecf54d4387a29d65fb037.jpg'
    },
    {
      id: 2,
      category: 'satuan',
      icon: 'ri-shirt-line',
      title: 'Laundry Satuan',
      description: 'Perawatan khusus untuk pakaian premium seperti jas, gaun, kebaya, dan pakaian berbahan sensitif',
      basePrice: 'Mulai dari Rp 15.000',
      priceUnit: '/pcs',
      estimatedTime: '3-4 hari',
      features: [
        'Perawatan khusus',
        'Cuci terpisah',
        'Setrika rapi',
        'Hanger premium',
        'Gratis antar jemput (area tertentu)'
      ],
      pricing: [
        { weight: 'Kemeja/Blouse', price: 'Rp 15.000' },
        { weight: 'Celana Panjang', price: 'Rp 15.000' },
        { weight: 'Jas', price: 'Rp 35.000' },
        { weight: 'Gaun/Dress', price: 'Rp 40.000' },
        { weight: 'Kebaya', price: 'Rp 50.000' },
        { weight: 'Sprei Single', price: 'Rp 20.000' },
        { weight: 'Sprei Double', price: 'Rp 30.000' },
        { weight: 'Selimut Tipis', price: 'Rp 25.000' },
        { weight: 'Selimut Tebal', price: 'Rp 40.000' }
      ],
      duration: '3-4 hari',
      image: 'https://readdy.ai/api/search-image?query=elegant%20formal%20clothes%20business%20shirts%20suits%20hanging%20on%20white%20hangers%20against%20light%20minimalist%20background%20with%20soft%20lighting%20emphasizing%20premium%20quality%20fabric%20care%20professional%20service&width=600&height=400&seq=laundry2&orientation=landscape'
    },
    {
      id: 3,
      category: 'cuci-setrika',
      icon: 'ri-temp-hot-line',
      title: 'Cuci + Setrika',
      description: 'Paket lengkap cuci bersih dan setrika rapi untuk pakaian siap pakai langsung',
      basePrice: 'Rp 9.000',
      priceUnit: '/kg',
      estimatedTime: '3-4 hari',
      features: [
        'Cuci bersih',
        'Setrika rapi',
        'Lipat teratur',
        'Pewangi',
        'Gratis antar jemput (min. 5kg)'
      ],
      pricing: [
        { weight: '3-5 kg', price: 'Rp 9.000/kg' },
        { weight: '6-10 kg', price: 'Rp 8.500/kg' },
        { weight: '> 10 kg', price: 'Rp 8.000/kg' }
      ],
      duration: '3-4 hari',
      image: 'https://readdy.ai/api/search-image?query=perfectly%20ironed%20folded%20fresh%20white%20shirts%20clothes%20stacked%20on%20light%20wooden%20surface%20with%20steam%20iron%20nearby%20bright%20clean%20setting%20emphasizing%20crisp%20neat%20professional%20laundry%20results&width=600&height=400&seq=laundry3&orientation=landscape'
    },
    {
      id: 4,
      category: 'setrika',
      icon: 'ri-iron-line',
      title: 'Setrika Saja',
      description: 'Khusus layanan setrika untuk pakaian yang sudah bersih tapi kusut',
      basePrice: 'Rp 5.000',
      priceUnit: '/kg',
      estimatedTime: '1-2 hari',
      features: [
        'Setrika profesional',
        'Lipat rapi',
        'Cepat selesai',
        'Harga terjangkau',
        'Gratis antar jemput (min. 5kg)'
      ],
      pricing: [
        { weight: '3-5 kg', price: 'Rp 5.000/kg' },
        { weight: '6-10 kg', price: 'Rp 4.500/kg' },
        { weight: '> 10 kg', price: 'Rp 4.000/kg' }
      ],
      duration: '1-2 hari',
      image: 'https://readdy.ai/api/search-image?query=modern%20electric%20iron%20on%20neatly%20folded%20white%20clothes%20against%20light%20blue%20background%20with%20steam%20effect%20bright%20clean%20setting%20emphasizing%20professional%20ironing%20service&width=600&height=400&seq=laundry4&orientation=landscape'
    },
    {
      id: 5,
      category: 'express',
      icon: 'ri-flashlight-line',
      title: 'Express Service',
      description: 'Layanan kilat untuk kebutuhan mendesak, selesai dalam 24 jam',
      basePrice: 'Rp 12.000',
      priceUnit: '/kg',
      estimatedTime: '24 jam',
      features: [
        'Selesai 24 jam',
        'Cuci + setrika',
        'Prioritas penanganan',
        'Garansi tepat waktu',
        'Gratis antar jemput (min. 5kg)'
      ],
      pricing: [
        { weight: '3-5 kg', price: 'Rp 12.000/kg' },
        { weight: '6-10 kg', price: 'Rp 11.500/kg' },
        { weight: '> 10 kg', price: 'Rp 11.000/kg' }
      ],
      duration: '24 jam',
      image: 'https://readdy.ai/api/search-image?query=fast%20delivery%20laundry%20service%20concept%20with%20clock%20timer%20fresh%20clean%20folded%20white%20clothes%20on%20light%20background%20emphasizing%20speed%20urgency%20quick%20turnaround%20professional%20express%20service&width=600&height=400&seq=laundry5&orientation=landscape'
    }
  ];

  const filteredServices = selectedCategory === 'all' 
    ? services 
    : services.filter(service => service.category === selectedCategory);

  const additionalServices = [
    {
      icon: 'ri-drop-line',
      title: 'Dry Cleaning',
      description: 'Untuk pakaian berbahan khusus yang tidak bisa dicuci basah'
    },
    {
      icon: 'ri-t-shirt-line',
      title: 'Cuci Sepatu',
      description: 'Layanan cuci sepatu dengan perawatan khusus'
    },
    {
      icon: 'ri-hotel-bed-line',
      title: 'Bed Cover & Sprei',
      description: 'Cuci bed cover, sprei, dan perlengkapan tidur'
    },
    {
      icon: 'ri-umbrella-line',
      title: 'Boneka & Karpet',
      description: 'Pembersihan boneka besar dan karpet'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 to-cyan-600"></div>
        <div className="absolute inset-0 opacity-10">
          <img 
            src="https://readdy.ai/api/search-image?query=comprehensive%20laundry%20service%20collection%20showing%20various%20clothing%20items%20washing%20machines%20ironing%20stations%20organized%20modern%20facility%20bright%20clean%20professional%20atmosphere%20emphasizing%20complete%20service%20range&width=1920&height=800&seq=layananherobg&orientation=landscape" 
            alt="Services Background"
            className="w-full h-full object-cover object-top"
          />
        </div>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Layanan Kami</h1>
            <p className="text-lg text-white/95 max-w-3xl mx-auto leading-relaxed">
              Berbagai pilihan layanan laundry profesional untuk memenuhi semua kebutuhan Anda
            </p>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-8 bg-white sticky top-20 z-40 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-all whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Free Pickup Banner */}
      <section className="py-6 bg-gradient-to-r from-emerald-50 to-cyan-50 border-y border-emerald-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center sm:text-left">
            <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
              <i className="ri-truck-line text-2xl text-emerald-600"></i>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-1">Gratis Antar Jemput!</h3>
              <p className="text-sm text-gray-600">Nikmati layanan antar jemput gratis untuk minimal pemesanan 5 kg di area jangkauan kami</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services List */}
      <section className="py-20 bg-gradient-to-b from-white to-blue-50/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {filteredServices.map((service, index) => (
              <div
                key={index}
                className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                  index % 2 === 1 ? 'lg:flex-row-reverse' : ''
                }`}
              >
                <div className={`${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-100">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                <div className={`${index % 2 === 1 ? 'lg:order-1' : ''}`}>
                  <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-xl mb-5">
                    <i className={`${service.icon} text-3xl text-blue-600`}></i>
                  </div>
                  
                  <h2 className="text-3xl font-bold text-gray-900 mb-4">{service.title}</h2>
                  <p className="text-base text-gray-600 mb-6 leading-relaxed">{service.description}</p>

                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">Fitur Layanan:</h4>
                    <ul className="space-y-2">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <i className="ri-checkbox-circle-fill text-blue-600 mt-1 mr-3 flex-shrink-0"></i>
                          <span className="text-sm text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl p-6 mb-6 border border-blue-100">
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">Harga:</h4>
                    <div className="space-y-2">
                      {service.pricing.map((price, idx) => (
                        <div key={idx} className="flex items-center justify-between">
                          <span className="text-sm text-gray-700">{price.weight}</span>
                          <span className="text-sm font-semibold text-blue-600">{price.price}</span>
                        </div>
                      ))}
                    </div>
                    <div className="mt-4 pt-4 border-t border-blue-200">
                      <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-700">Estimasi waktu:</span>
                        <span className="text-sm font-semibold text-gray-900">{service.duration}</span>
                      </div>
                    </div>
                  </div>

                  <a
                    href="https://wa.me/62895338139977?text=Halo%20YEZ%20Laundry%2C%20saya%20ingin%20memesan%20layanan%20laundry"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-teal-600 font-medium text-sm hover:text-teal-700 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line mr-2"></i>
                    Pesan via WhatsApp
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Layanan Tambahan</h2>
            <p className="text-base text-gray-600 max-w-2xl mx-auto">
              Layanan khusus lainnya yang tersedia di YEZ Laundry
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {additionalServices.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 hover:shadow-xl transition-all text-center"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-blue-100 rounded-xl mx-auto mb-4">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>

          <div className="text-center mt-12">
            <p className="text-sm text-gray-600 mb-6">Untuk informasi harga dan detail layanan tambahan, hubungi kami</p>
            <a
              href="https://wa.me/62895338139977?text=Halo%20YEZ%20Laundry%2C%20saya%20ingin%20menanyakan%20layanan%20tambahan"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center bg-blue-600 text-white px-8 py-3 rounded-full text-base font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line mr-2 text-xl"></i>
              Tanya Layanan Lainnya
            </a>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gradient-to-b from-blue-50/30 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Pertanyaan Umum</h2>
            <p className="text-base text-gray-600">
              Jawaban untuk pertanyaan yang sering ditanyakan
            </p>
          </div>

          <div className="space-y-4">
            {[
              {
                question: 'Berapa minimal kiloan untuk layanan laundry?',
                answer: 'Minimal pemesanan untuk layanan laundry kiloan adalah 3 kg. Untuk layanan antar jemput gratis, minimal 5 kg.'
              },
              {
                question: 'Apakah ada garansi jika pakaian rusak atau hilang?',
                answer: 'Ya, kami memberikan garansi untuk kerusakan yang disebabkan oleh proses laundry kami. Setiap pakaian akan dicatat dan dijaga dengan hati-hati.'
              },
              {
                question: 'Bagaimana cara pemesanan layanan antar jemput?',
                answer: 'Anda dapat menghubungi kami via WhatsApp atau telepon untuk menjadwalkan penjemputan. Tim kami akan datang ke lokasi Anda sesuai jadwal.'
              },
              {
                question: 'Apakah bisa request waktu pengerjaan tertentu?',
                answer: 'Tentu! Anda dapat memilih layanan express untuk pengerjaan lebih cepat, atau memberitahu kami kebutuhan waktu spesifik Anda.'
              },
              {
                question: 'Apa metode pembayaran yang tersedia?',
                answer: 'Kami menerima pembayaran tunai, transfer bank, dan e-wallet (OVO, GoPay, Dana, dll). Pembayaran dilakukan saat pengambilan cucian.'
              }
            ].map((faq, index) => (
              <details key={index} className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
                <summary className="px-6 py-5 cursor-pointer hover:bg-gray-50 transition-colors flex items-center justify-between">
                  <span className="font-semibold text-gray-900 text-sm">{faq.question}</span>
                  <i className="ri-arrow-down-s-line text-xl text-gray-400"></i>
                </summary>
                <div className="px-6 pb-5">
                  <p className="text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-blue-600 to-cyan-600">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Siap Menggunakan Layanan Kami?
          </h2>
          <p className="text-lg text-white/95 mb-10 max-w-2xl mx-auto leading-relaxed">
            Hubungi kami sekarang untuk konsultasi gratis dan dapatkan penawaran terbaik untuk kebutuhan laundry Anda
          </p>
          <a
            href="https://wa.me/62895338139977?text=Halo%20YEZ%20Laundry%2C%20saya%20ingin%20memesan%20layanan%20laundry"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Pesan via WhatsApp
          </a>
          <a
            href="tel:+62895338139977"
            className="inline-flex items-center justify-center bg-white text-teal-600 px-6 py-3 rounded-lg text-sm font-semibold border-2 border-teal-600 hover:bg-teal-50 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line mr-2"></i>
            Hubungi Kami
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
